"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/treatmentSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TreatmentSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "treatment" */
    alt?: string;
    /** Detected variants: "/Templates/Doccure/img/about/slide-01.jpg" | "/Templates/Doccure/img/about/slide-02.jpg" */
    draggableSlider0AfterImage: string;
    /** Detected variants: "/Templates/Doccure/img/about/slide-lg-01.jpg" | "/Templates/Doccure/img/about/slide-lg-02.jpg" */
    draggableSlider0BeforeImage: string;
};
export type HomeFourteenTreatmentSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "Advanced Dermatology Treatments" */
    sectionDiv0H20H2Text?: ReactNode;
    sectionDiv0H20H2Visible?: boolean;
    sectionDiv0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "skin care" */
    sectionDiv0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/skincare-01.png" */
    sectionDiv0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Enhanced" */
    sectionDiv0H20Span1SpanText?: ReactNode;
    /** Default: "skin care" */
    sectionDiv0H20Span2ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/skincare-02.png" */
    sectionDiv0H20Span2ImageWithBasePath0ImageSrc?: string;
    sectionDiv0H20Span2ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0H20Span2ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20Span2ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Patient Care." */
    sectionDiv0H20Span3SpanText?: ReactNode;
    treatmentSection6s: TreatmentSection6sItem[];
    treatmentSection6sItemWrapper?: (item: TreatmentSection6sItem, content: ReactNode) => ReactNode;
    treatmentSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeFourteenTreatmentSectionGenerated: FC<HomeFourteenTreatmentSectionGeneratedProps> = ({
    sectionDiv0H20H2Text = "Advanced Dermatology Treatments",
    sectionDiv0H20H2Visible,
    sectionDiv0H20H2Renderer,
    sectionDiv0H20H2Props,
    sectionDiv0H20Span0ImageWithBasePath0ImageAlt = "skin care",
    sectionDiv0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/skincare-01.png",
    sectionDiv0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0H20Span1SpanText = "Enhanced",
    sectionDiv0H20Span2ImageWithBasePath0ImageAlt = "skin care",
    sectionDiv0H20Span2ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/skincare-02.png",
    sectionDiv0H20Span2ImageWithBasePath0ImageVisible,
    sectionDiv0H20Span2ImageWithBasePath0ImageRenderer,
    sectionDiv0H20Span2ImageWithBasePath0ImageProps,
    sectionDiv0H20Span3SpanText = "Patient Care.",
    sectionDiv0Div0ClassName,
    treatmentSection6s,
    treatmentSection6sItemWrapper,
    treatmentSection6sRenderer,
}) => {
    return (
        <section className="treatment-section section">
            <div className="container">
                {renderNode(sectionDiv0H20H2Visible, sectionDiv0H20H2Renderer, (
                    <h2 {...(sectionDiv0H20H2Props ?? {})}>
                        {sectionDiv0H20H2Text}
                        {" "}
                        <span className="care-img bg-primary">
                            {renderNode(sectionDiv0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0H20Span0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </span>
                        {" "}
                        <span className="text-secondary">{sectionDiv0H20Span1SpanText}</span>
                        <span className="care-img bg-secondary">
                            {renderNode(sectionDiv0H20Span2ImageWithBasePath0ImageVisible, sectionDiv0H20Span2ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0H20Span2ImageWithBasePath0ImageSrc} alt={sectionDiv0H20Span2ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0H20Span2ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </span>
                        {" "}
                        <span className="text-secondary">{sectionDiv0H20Span3SpanText}</span>
                    </h2>
                ))}
                <div className={sectionDiv0Div0ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        treatmentSection6s,
                        (item: TreatmentSection6sItem) => (
                            <div className={item.className ?? "col-md-6 d-flex"} key={item.key}>
                                <div data-template-tag="DraggableSlider" />
                            </div>
                        ),
                        treatmentSection6sItemWrapper,
                        treatmentSection6sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFourteenTreatmentSectionGenerated;
